import configs from "../../config";

const envName = process.env.APP_ENV || "local";
const config = configs[envName as unknown as keyof typeof configs];

if (!config) throw new Error();

export { config };
